import { objectKeys, nullishFilter, formatUserInitials, formatFullName } from '@caresend/utils';
import { defineComponent, ref, computed, watchEffect } from 'vue';
import InfoCircleIcon from '../../../../../../assets/icons/info-circle.svg.js';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$1 from '../../../../../inputs/Checkbox.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import { showIntercomMessenger } from '../../../../../../functions/intercom.js';
import { getStore } from '../../../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'ItineraryWaypointPatientConsent',
    components: {
        InfoCircleIcon,
        BasicCard: __vue_component__,
        Checkbox: __vue_component__$1,
    },
    model: {
        prop: 'value',
        event: 'update:value',
    },
    props: {
        waypointActionID: {
            type: String,
            required: true,
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const store = getStore();
        const { waypointActions, procedures } = usePortalStore();
        const hasPatientAgreed = ref(false);
        const procedure = computed(() => {
            var _a, _b, _c;
            return procedures.getRaw(((_c = objectKeys((_b = (_a = waypointActions.get(props.waypointActionID)) === null || _a === void 0 ? void 0 : _a.procedures) !== null && _b !== void 0 ? _b : {}).filter(nullishFilter)[0]) !== null && _c !== void 0 ? _c : '').toString());
        });
        const billTo = computed(() => { var _a, _b; return (_b = (_a = procedure.value) === null || _a === void 0 ? void 0 : _a.billTo) !== null && _b !== void 0 ? _b : 'unknown biller'; });
        const labelBiller = computed(() => {
            switch (billTo.value) {
                case 'patient':
                    return 'the lab will bill you';
                case 'client':
                    return 'the lab will bill your doctor';
                default:
                    return 'the lab will bill your insurance';
            }
        });
        const taskName = computed(() => { var _a, _b, _c; return (_c = (_b = store.getters['variables/getTaskByID']((_a = procedure.value) === null || _a === void 0 ? void 0 : _a.taskID)) === null || _b === void 0 ? void 0 : _b.info.friendlyName) !== null && _c !== void 0 ? _c : 'unknown task'; });
        const patient = computed(() => { var _a; return procedures.getters.patient((_a = procedure.value) !== null && _a !== void 0 ? _a : ''); });
        const prescriber = computed(() => { var _a, _b; return procedures.getters.prescriber((_b = (_a = procedure.value) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ''); });
        const patientInitials = computed(() => formatUserInitials(patient.value));
        const prescriberName = computed(() => formatFullName(prescriber.value));
        const patientName = computed(() => formatFullName(patient.value));
        watchEffect(() => emit('update:value', !hasPatientAgreed.value));
        return {
            billTo,
            hasPatientAgreed,
            patientInitials,
            patientName,
            prescriberName,
            procedure,
            taskName,
            showIntercomMessenger,
            labelBiller,
        };
    },
});

export { script as default };
